import { FC } from 'react';

interface PropsType {
  bgColor?: string;
}

const Loader: FC<PropsType> = ({ bgColor }) => {
  const ellipsisColor = bgColor ?? 'bg-white';

  return (
    <div className="center-absolute">
      <div className="lds-ellipsis">
        <div className={ellipsisColor}></div>
        <div className={ellipsisColor}></div>
        <div className={ellipsisColor}></div>
        <div className={ellipsisColor}></div>
      </div>
    </div>
  );
};

export default Loader;
